<template>
  <Content :button-create-show="false">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getDocType as fetchData } from "@/api/docType";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "type",
  edit: true,
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
    sortable: false,
  },
  {
    prop: "type",
    label: "Название типа документа",
    sortable: false,
  },
  {
    prop: "description",
    label: "Описание типа",
    sortable: false,
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
